import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetAdminContactsQueryVariables = Types.Exact<{
  userIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type GetAdminContactsQuery = { __typename?: 'query_root', dealer_viewable_admin_info: Array<{ __typename?: 'dealer_viewable_admin_info', user_id?: number | null, display_name?: string | null, email?: string | null, phone?: string | null }> };


export const GetAdminContactsDocument = gql`
    query getAdminContacts($userIds: [bigint!]!) {
  dealer_viewable_admin_info(where: {user_id: {_in: $userIds}}) {
    user_id
    display_name
    email
    phone
  }
}
    `;

/**
 * __useGetAdminContactsQuery__
 *
 * To run a query within a React component, call `useGetAdminContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminContactsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetAdminContactsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminContactsQuery, GetAdminContactsQueryVariables> & ({ variables: GetAdminContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminContactsQuery, GetAdminContactsQueryVariables>(GetAdminContactsDocument, options);
      }
export function useGetAdminContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminContactsQuery, GetAdminContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminContactsQuery, GetAdminContactsQueryVariables>(GetAdminContactsDocument, options);
        }
// @ts-ignore
export function useGetAdminContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminContactsQuery, GetAdminContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminContactsQuery, GetAdminContactsQueryVariables>;
export function useGetAdminContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminContactsQuery, GetAdminContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminContactsQuery | undefined, GetAdminContactsQueryVariables>;
export function useGetAdminContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminContactsQuery, GetAdminContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminContactsQuery, GetAdminContactsQueryVariables>(GetAdminContactsDocument, options);
        }
export type GetAdminContactsQueryHookResult = ReturnType<typeof useGetAdminContactsQuery>;
export type GetAdminContactsLazyQueryHookResult = ReturnType<typeof useGetAdminContactsLazyQuery>;
export type GetAdminContactsSuspenseQueryHookResult = ReturnType<typeof useGetAdminContactsSuspenseQuery>;
export type GetAdminContactsQueryResult = Apollo.QueryResult<GetAdminContactsQuery, GetAdminContactsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/layout/queries/getAdminContacts.query.gql}
 */
export async function getAdminContacts(
  variables: GetAdminContactsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAdminContactsQuery['dealer_viewable_admin_info']>
export async function getAdminContacts(
  variables: GetAdminContactsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAdminContactsQuery>
export async function getAdminContacts(
  variables: GetAdminContactsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAdminContactsQuery['dealer_viewable_admin_info'] | GetAdminContactsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAdminContactsQuery>(
    GetAdminContactsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.dealer_viewable_admin_info
}